{
  "confirmPassword": "Neues Passwort wiederholen",
  "loginNow": "Jetzt anmelden",
  "newPassword": "Neues Passwort",
  "noToken": "Dieser Link ist unvollständig. Öffnen Sie den Link aus der E-Mail erneut.",
  "passwordMismatch": "Die Passwörter stimmen nicht überein.",
  "submit": "Passwort setzen",
  "successMessage": "Sie können sich jetzt mit dem neuen Passwort anmelden. Sie werden zur Anmeldung weitergeleitet …",
  "successTitle": "Passwort geändert",
  "title": "Neues Passwort wählen"
}
